import { render, staticRenderFns } from "./MiniTypeTable.vue?vue&type=template&id=61d5b180&scoped=true"
import script from "./MiniTypeTable.vue?vue&type=script&lang=js"
export * from "./MiniTypeTable.vue?vue&type=script&lang=js"
import style0 from "./MiniTypeTable.vue?vue&type=style&index=0&id=61d5b180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d5b180",
  null
  
)

export default component.exports